@if (isPreview !== true) {
    <div class="wrapper" websiteTheme [colorScheme]="colorScheme">
        <div class="error">
            <div class="error__inner">
                <h1 class="error__heading">
                    {{ 'Something went wrong' | translate }}
                </h1>
                <h2 class="error__subtitle">
                    {{ 'Whoops, that page is gone.' | translate }}<br />
                    {{ 'But we’ve got something even better for you.' | translate }}
                </h2>
                <div>
                    <a
                        website-link
                        [href]="pathToLocaleRootHomePage"
                        [size]="'large'"
                        [direction]="'to-left'"
                        [contextColorScheme]="colorScheme"
                        >{{ 'Go to Homepage' | translate }}</a
                    >
                </div>
            </div>
        </div>
    </div>
}
